<template>
    <div class="home">

        <!--                <div style="width: 100%; height: 110px; background-color:#f7f7f7">-->

        <Nav2></Nav2>
        <!--                </div>-->
        <StarDemo></StarDemo>

        <div id="content">
            <label id="menu-toggle" for="menu-input" @click="fp2()">{{ hide }}</label>
                <input id="menu-input" type="checkbox"></input>
            <div class="third-nav" style="">

                <ul>
                    <li :class="{active: currentPage === 'one'}" @click="scroll('one')">
                        <span>环评项目</span>
                    </li>
                    <li :class="{active: currentPage === 'two'}" @click="scroll('two')">
                        <span>编制单位</span>
                    </li>
                    <li :class="{active: currentPage === 'three'}" @click="scroll('three')">
                        <span>编制人员</span>
                    </li>

                </ul>
            </div>
            <div class="banner" id="one">

                <CreditProjectSearchv2
                        :compile_host_code="this.$route.query.compile_host_code"
                        :compile_unit_name="this.$route.query.compile_unit_name"></CreditProjectSearchv2>
            </div>
            <div class="banner" id="two">

                <CompileUnitSearchv2></CompileUnitSearchv2>

            </div>
            <div class="banner" id="three">

                <CompileHostSearchv2></CompileHostSearchv2>
            </div>
            <div class="shang" style="">
                <ul>
                    <li :class="{active: currentPage === 'one'}" @click="scroll('one')">
                        <img src='../../../assets/img/上.png'>
                    </li>

                    <li :class="{active: currentPage === 'three'}" @click="scroll('three')">
                        <img src='../../../assets/img/下.png'>
                    </li>

                </ul>
            </div>
        </div>
        <Foot2></Foot2>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Nav2 from '../../../components/v2/Nav2'
    import Foot2 from "../../../components/v2/Foot2";
    import StarDemo from "../../../components/v2/StarDemo";
    import CompileUnitSearchv2 from "../../../components/v2/credit_project/data_search/CompileUnitSearchv2";
    import CreditProjectSearchv2 from "../../../components/v2/credit_project/data_search/CreditProjectSearchv2";
    import CompileHostSearchv2 from "../../../components/v2/credit_project/data_search/CompileHostSearchv2";

    export default {
        name: 'HPDataSearchv2',
        data() {
            return {
                i: 0,
                currentPage: '',
                input: '',
                hide_bool: 0,
                hide: '',
            }
        },
        components: {
            Nav2,
            Foot2,
            StarDemo,
            CompileUnitSearchv2,
            CreditProjectSearchv2,
            CompileHostSearchv2,
        },
        methods: {
            fp2() {
                if (this.hide_bool === 1) {
                    this.hide = "显示侧边";
                    this.hide_bool = 0;
                } else {
                    this.hide = "隐藏侧边";
                    this.hide_bool = 1;
                }

                // var txt_t2 = document.getElementById("menu-toggle").value;
                // txt_t2.innerText = "dfasdf";
            },
            scroll: function (page) {
                document.getElementById(page).scrollIntoView({behavior: 'smooth'})
                // this.currentPage = page

            },

        },
        created() {
            this.fp2();
            this.currentPage = 'one';
            window.addEventListener("scroll", () => {

                    var drection = window.scrollY - this.i;
                    if (drection > 0) {
                        if (window.scrollY > 700 & window.scrollY < 1400) {
                            this.currentPage = 'two';
                        }
                        if (window.scrollY > 1400) {
                            this.currentPage = 'three';
                        }
                        if (window.scrollY < 900) {
                            this.currentPage = 'one';
                        }
                    }
                    if (drection < 0) {
                        if (window.scrollY > 300 & window.scrollY < 1200) {
                            this.currentPage = 'two';
                        }
                        if (window.scrollY > 1200) {
                            this.currentPage = 'three';
                        }
                        if (window.scrollY < 300) {
                            this.currentPage = 'one';
                        }
                    }

                    console.log(window.scrollY);
                    console.log(drection);
                    this.i = window.scrollY;
                }
            )

        },
        mounted() {
            this.scroll('one')
            // document.addEventListener('scroll', this.handleScroll, true);compile_host_code

        }

    }
</script>
<style scoped>
    * {
        box-sizing: border-box;
        font-family: "Microsoft YaHei", 微软雅黑;
    }


    .home {
        background: radial-gradient(200% 100% at bottom center, #f7f7b6, #e96f92);
        background: radial-gradient(220% 105% at top center, #1b2947 20%, #75517d 60%, #e96f92 95%, #f7f7b6);
        position: relative;
        /*position: fixed;*/
        width: 100%;
        /*height: 300vh;*/

        overflow: hidden;
    }


    .banner {
        height: 100vh;

        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0.8;
    }

    #two {
        /*background-color: #2271b7;*/
    }

    #three {
        /*background-color: #71a4d1;*/
    }

    .shang {
        color: #f7f7b6;
        font-size: 18px;

        z-index: 20;
        position: fixed;
        right: 44px;
        top: 45%;

    }

    .shang img:hover {
        cursor: pointer;
        background-color: #75517d;
    }

    .shang li {
        margin-top: 40px;
        margin-bottom: 40px;
    }

    #menu-input {
        z-index: 30;
        position: fixed;
        left: 20px;
        top: 20%;
    }

    #menu-toggle {
        font-size: 16px;
        color: #f7f7b8;
        z-index: 30;
        position: fixed;
        left: 20px;
        top: 80px;
        padding: 10px 10px;
        user-select: none;

    }


    #menu-toggle:hover {
        cursor: pointer;
        color: #f71ea3
    }

    #menu-input:checked ~ .third-nav {
        display: none;
    }


    #menu-input {
        display: none;
    }

    .third-nav {
        color: #f71ea3;
        font-size: 16px;
        z-index: 20;
        position: fixed;
        left: 20px;
        top: 20%;

    }


    .third-nav ul {
        font-weight: bold;
    }

    .third-nav li {
        margin-top: 20px;
        margin-bottom: 10px;
        padding-bottom: 5px;
    }

    .third-nav li:hover {
        cursor: pointer;
        /*color: #f7f7f7;*/
        border-bottom: 2px solid #f7f7b6;


    }

    .third-nav li.active {
        cursor: pointer;
        color: #f7f7b6;
        border-bottom: 2px solid #f7f7b6;
    }

    /*#content {*/
    /*        width: 1660px;*/
    /*        height: 810px;*/
    /*    !*    position: relative;*!*/
    /*    !*    background-color: #dfebf5;*!*/
    /*    !*    margin-bottom: 20px;*!*/
    /*    !*    margin-left: 20px;*!*/
    /*     overflow-y: scroll;*/
    /*}*/
</style>